import { InternalAxiosRequestConfig } from 'axios';

const DEMO_MODE_KEY = 'demo-mode-enabled';

// Routes where demo mode is allowed
const DEMO_MODE_INCLUDED_PATHS = [
  /^(?:\/[^/]+)?\/dashboard\/admin(\/|$)/,
  /^(?:\/[^/]+)?\/reports-summary(\/|$)/,
  /^(?:\/[^/]+)?\/reports-awareness(\/|$)/,
  /^(?:\/[^/]+)?\/phishing-analytics(\/|$)/,
  /^(?:\/[^/]+)?\/custom-materials(\/|$)/,
  /^(?:\/[^/]+)?\/users(\/|$)/,
  /^(?:\/[^/]+)?\/branches(\/|$)/,
  /^(?:\/[^/]+)?\/groups(\/|$)/,
  /^(?:\/[^/]+)?\/campaigns(\/|$)/,
  /^(?:\/[^/]+)?\/enrollment\/training-planner(\/|$)/,
  /^(?:\/[^/]+)?\/security-culture-survey(\/|$)/,
  /^(?:\/[^/]+)?\/awareness-training-analytics(\/|$)/,
];

// Pages where demo mode is readonly
const PAGES_READONLY_IN_DEMO_MODE = [
  /^(?:\/[^/]+)?\/users\//,
  /^(?:\/[^/]+)?\/groups\//,
  /^(?:\/[^/]+)?\/branches\//,
  /^(?:\/[^/]+)?\/custom-materials\//,
  /^(?:\/[^/]+)?\/campaigns\/report\//,
];

export const isDemoModeActive = (): boolean => {
  const stored = sessionStorage.getItem(DEMO_MODE_KEY);
  return stored === 'true';
};

export const setDemoMode = (enabled: boolean): void => {
  sessionStorage.setItem(DEMO_MODE_KEY, enabled.toString());
};

export const clearDemoMode = (): void => {
  sessionStorage.removeItem(DEMO_MODE_KEY);
};

export const isDemoModeAllowedOnCurrentPage = (): boolean => {
  const currentPath = window.location.pathname;

  return DEMO_MODE_INCLUDED_PATHS.some((regex) => regex.test(currentPath));
};

export const isDemoModeReadonlyPage = (): boolean => {
  const currentPath = window.location.pathname;

  return PAGES_READONLY_IN_DEMO_MODE.some((regex) => regex.test(currentPath));
};

export const shouldUseDemoModeForRequest = (
  config: InternalAxiosRequestConfig,
): boolean => {
  if (
    !isDemoModeActive() ||
    !isDemoModeAllowedOnCurrentPage() ||
    config.params?.ignoreDemoMode
  ) {
    return false;
  }

  const methodLower = config.method?.toLowerCase();
  const currentPath = window.location.pathname;

  // GET requests always use demo mode
  if (methodLower === 'get') {
    return true;
  }

  // POST requests only use demo mode if they're export requests on summary/awareness pages
  if (methodLower === 'post') {
    const isExportPage =
      /^(?:\/[^/]+)?\/reports-summary(\/|$)/.test(currentPath) ||
      /^(?:\/[^/]+)?\/reports-awareness(\/|$)/.test(currentPath) ||
      /^(?:\/[^/]+)?\/campaigns\/report(\/|$)/.test(currentPath);

    return isExportPage;
  }

  return false;
};
